export class Settings {
  
  ProfilebaseUrl: string;
  adminbaseUrl:string;
  EmployerbaseUrl:string;
  EmailbaseUrl:string;
 }
